import uuid from "uuid/v4";
import { logger } from '../logging/logger';

const log = logger('http_client');

const getCommonHeaders = token => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json; charset=utf-8");
  headers.append("X-RequestId", uuid());
  if (token) {
    headers.append("Authorization", "Bearer " + token);
  }

  return headers;
};

const getCommonConfig = (token, abortSignal) => {
  const headers = getCommonHeaders(token);

  const config = {
    credentials: "include",
    headers: headers,
    signal: abortSignal
  };

  return config;
};

const executeFetch = (url, config) => {
  return new Promise((resolve, reject) => {
    fetch(url, config)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then(json => {
        resolve(json);
      })
      .catch(responseError => {
        try {
          switch (responseError.status) {
            case 404:
              reject({ status: responseError.status, error: "Not found" });
              break;
            case 401:
              reject({ status: responseError.status, error: "Not Authorized" });
              break;
            default:
              responseError.json().then(body => {
                log.debug({ catch: "error", body: body });
                reject({ status: responseError.status, error: body });
              });
          }
        } catch (e) {
          log.debug({ catch: "catch", error: responseError.name});
          if (responseError.name && responseError.name === "AbortError") {
            reject({ status: "Abort", error: responseError });
          } else {
            reject({ status: responseError.status, error: responseError });
          }
        }
      });
  });
};

const rawGet = async (url, token, data, abortSignal) => {
  if (data) {
    log.warn("should convert data to query string");
  }

  const config = {
    ...getCommonConfig(token, abortSignal),
    method: "GET"
  };

  return fetch(url, config);
};

const get = async (url, token, data, abortSignal) => {
  if (data) {
    log.warn("should convert data to query string");
  }

  const config = {
    ...getCommonConfig(token, abortSignal),
    method: "GET"
  };

  return executeFetch(url, config);
};

const post = async (url, token, data, abortSignal) => {
  const config = {
    ...getCommonConfig(token, abortSignal),
    method: "POST",
    body: JSON.stringify(data)
  };

  return executeFetch(url, config);
};

const deleteM = async (url, token, data, abortSignal) => {
  if (data) {
    log.warn("should convert data to query string");
  }

  const config = {
    ...getCommonConfig(token, abortSignal),
    method: "DELETE"
  };

  return executeFetch(url, config);
};

export const httpClient = {
  get,
  post,
  delete: deleteM,
  rawGet
};

export const userInfoBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/userInfo`;
export const geoBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/geo`;
export const vatBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/vat`;
export const planBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/plans`;
export const subscriptionBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/subscription`;
export const billingInformationBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/billingInfo`;
export const paymentMethodsBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/paymentMethods`;
export const invoicesBaseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/invoices`;
export const exportDataBaseUrl = `${process.env.REACT_APP_APIV2_ENDPOINT}/api/v1.0/dataManagement/export`;